import * as React from 'react';
const ModalDialogSizeContext = /*#__PURE__*/React.createContext(undefined);
export default ModalDialogSizeContext;